import React from 'react'
import _ from 'lodash'
import { Tooltip } from 'antd'
import { Icon, Div } from 'konsys-ui'
import { ChevronsUpDown } from 'lucide-react'
import {
  InputWithPlaceHolder, ActionSelector, HeaderLabel, CellText,
} from '../../../components/mechanics-components'
import { theme } from '../../../styles/_variables'

const { color } = theme

export default {
  columns: [{
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          ชื่อ <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'firstname',
    sortable: true,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 250,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          แผนก <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'department',
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.fullname, filter.value),
    sortable: true,
    filterable: true,
    width: 170,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          Email
        </HeaderLabel>
      </Div>
    ),
    accessor: 'email',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 220,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          เบอร์โทรศัพท์
        </HeaderLabel>
      </Div>
    ),
    accessor: 'phoneNumber',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 150,
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <ActionSelector props={props} />,
    width: 150,
  }],
}
